export default __webpack_public_path__ + "static/media/loginMap.2fcab7a7.svg";